/* eslint-disable no-unused-vars */

import {
  recordPageReady,
  recordMark,
} from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import { useGetShopProductsQuery } from './getShopProducts';
import mockedResponse from './useShopProductQuery.mockedResponse';

const useShopProductQuery = ({
  productSkuId,
  externalProductId,
  gated,
  skip,
}) => {
  const {
    data: shopProductData,
    loading: shopProductLoading,
    error: shopProductError,
  } = useGetShopProductsQuery({
    skip: !(productSkuId || externalProductId) || skip,
    variables: {
      skuId: productSkuId || '',
      externalProductId: externalProductId || '',
      useExternalId: !productSkuId,
      gated: !!gated,
    },
    onCompleted: () => {
      recordMark('get_shop_products_graph_query_completed', {
        graph_query_succeeded: true,
      });

      const onPageReadyMedia =
        // if we aren't using a specific sku, fallback to the default variant
        shopProductData.shopProductBySkuId?.variantBySkuId?.media ||
        shopProductData.shopProductByExternalProductId?.defaultVariant?.media;

      const resources = onPageReadyMedia
        // style cards conditionally render, so we don't want to wait for them
        .filter(mediaObject => mediaObject?.category !== 'style_card')
        // Pager does some transformations on the URLs, we should use a fuzzy match
        .map(mediaObject => {
          return mediaObject?.originalSrc?.match(/http.*upload\/(.*)/)?.[1];
        });

      recordPageReady({
        // page will record as ready once all the media
        // associated with the primary sku have loaded
        resources,
      });
    },
    onError: () => {
      recordMark('get_shop_products_graph_query_completed', {
        graph_query_succeeded: false,
      });

      sendLog(
        `GetShopProducts error for sku ID ${productSkuId}: ${shopProductError}`,
        {
          sku_id: productSkuId,
          error_message: shopProductError,
        },
      );
    },
  });

  if (window.gon.use_mock_graphql_data) {
    return {
      shopProductData: mockedResponse.data,
      shopProductLoading,
      shopProductError,
    };
  }

  return { shopProductData, shopProductLoading, shopProductError };
};

export default useShopProductQuery;
